// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"0ff62d01","75":"5fdc8a5b","116":"15333277","453":"88d7063c"}[chunkId] + ".chunk.js";
};